module.exports = __webpack_public_path__ + "static/media/remote.schema.e5699162.graphql";